interface ISortConfig<T> {
    accessor: keyof T;
    desc: boolean;
}

export default class ArrayHelper {
    public static isSameDateArray(value1?: Date[], value2?: Date[]) {
        return ArrayHelper.isSameArray(value1, value2, x => x.getTime());
    }

    public static isSameArray<T>(value1?: T[], value2?: T[], valueSelector?: (item: T) => unknown) {
        if ((!value1 && value2) || (value1 && !value2)) return false;

        if (!value1 && !value2) return true;

        //never happen
        if (!value1 || !value2) return true;

        if (value1.length !== value2.length) return false;

        for (let i = 0; i < value1.length; i++) {
            if (!valueSelector && value1[i] !== value2[i]) return false;
            if (valueSelector && valueSelector(value1[i]) !== valueSelector(value2[i])) return false;
        }
        return true;
    }

    public static distinctBy<T, TKey>(array: T[], mapFn: (el: T) => TKey) {
        const itemsMap = new Map<TKey, T>();
        array.forEach((el) => {
            const key = mapFn(el);
            const hasItem = itemsMap.has(key);
            if (!hasItem) {
                itemsMap.set(key, el);
            }
        });

        return [...itemsMap.values()];
    }

    public static groupBy<T, TKey>(array: T[], mapFn: (el: T) => TKey) {
        const map = new Map<TKey, T[]>();
        array.forEach((item) => {
            const key = mapFn(item);
            const collection = map.get(key);
            if (!collection) {
                map.set(key, [item]);
            } else {
                collection.push(item);
            }
        });
        return [...map.keys()].map(key => {
            return {
                key: key,
                values: map.get(key) || []
            };
        });
    }

    public static sortByAccessor<T extends { [p in keyof T]: string | number | Date }>(config: ISortConfig<T> | undefined, isDate: boolean = false, caseSensitive: boolean = false) {
        return (a: T, b: T) => {
            if (!config) {
                return 0;
            }

            let valueA: number | string | Date = a[config.accessor];
            let valueB: number | string | Date = b[config.accessor];

            if (!caseSensitive && typeof valueA === 'string' && typeof valueB === 'string') {
                valueA = valueA.toLowerCase();
                valueB = valueB.toLowerCase();
            }

            if (isDate && typeof valueA === 'string' && typeof valueB === 'string') {
                valueA = new Date(valueA);
                valueB = new Date(valueB);
            }

            return (valueA < valueB ? -1 : valueA > valueB ? 1 : 0) * (config.desc ? -1 : 1);
        };
    }
}
